import { configureStore } from '@reduxjs/toolkit';
// import logger from 'redux-logger';
import sendSlice from './enviarMail'

const store = configureStore({
  middleware: getDefaultMiddleware => getDefaultMiddleware().concat(),
  reducer: {
    send: sendSlice,
  },
});

export default store;
